module.exports = __webpack_public_path__ + "static/11-fd4c34899c94a786005a44471dfd81dd.jpg";